export default "__VITE_ASSET__JM8n3AyA__";